<div id="cellarAddPopup" fxLayout="column">
  <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
    <h1>
      {{ isEditMode ? "ویرایش" : "اضافه کردن آیتم جدید" }}
    </h1>

    <div class="actions">
      <button *ngIf="isEditMode && target === 'binding'" [disabled]="!bindingFormGroup.dirty || !bindingFormGroup.valid"
        mat-raised-button (click)="updateBinding()" color="accent">
        بروز رسانی صحافی
        <jam-icon name="check" vertical-align="middle" />
      </button>

      <button *ngIf="isEditMode && target === 'bindingSalaryFee'" [disabled]="!bindingSalaryFeeFormGroup.dirty || !bindingSalaryFeeFormGroup.valid"
      mat-raised-button (click)="updateBindingSalaryFee()" color="accent">
      بروز رسانی دستمزد ثابت صحافی
      <jam-icon name="check" vertical-align="middle" />
    </button>
      <button *ngIf="isEditMode && target === 'color'"
        [disabled]="!talcColorFormGroup.dirty || !talcColorFormGroup.valid" mat-raised-button (click)="updateColor()"
        color="accent">
        بروز رسانی رنگ
        <jam-icon name="check" vertical-align="middle" />
      </button>

      <button *ngIf="isEditMode && target === 'type'  && pointer != 'کاور'" [disabled]="!typeFormGroup.dirty || !typeFormGroup.valid"
        mat-raised-button color="accent" (click)="updateSize()">
        بروز رسانی
        <jam-icon name="check" vertical-align="middle" />
      </button>
      <button *ngIf="isEditMode && target === 'type'  && pointer == 'کاور'" [disabled]="!typeCoverFormGroup.dirty || !typeCoverFormGroup.valid"
      mat-raised-button color="accent" (click)="updateCover()">
      بروز رسانی
      <jam-icon name="check" vertical-align="middle" />
    </button>
      <button [disabled]="!isEditMode || target === 'bindingSalaryFee'" (click)="deleteBinding()" color="warn" mat-button>
        <span>حذف آیتم</span>
        <jam-icon name="remove" vertical-align="middle" />
      </button>

      <button (click)="addSize()" *ngIf="!isEditMode && target === 'type'"
        [disabled]="!(typeFormGroup.valid || bindingFormGroup.valid)" mat-raised-button color="primary">
        اضافه کردن اندازه
        <jam-icon name="plus" vertical-align="middle" />
      </button>

      <button (click)="addBinding()" *ngIf="!isEditMode && target === 'binding'"
        [disabled]="!(typeFormGroup.valid || bindingFormGroup.valid)" mat-raised-button color="primary">
        اضافه کردن صحافی
        <jam-icon name="plus" vertical-align="middle" />
      </button>

      <button (click)="addColor()" *ngIf="!isEditMode && target === 'color'"
        [disabled]="!(typeFormGroup.valid || bindingFormGroup.valid)" mat-raised-button color="primary">
        اضافه کردن رنگ
        <jam-icon name="plus" vertical-align="middle" />
      </button>

      <jam-icon name="close" class="close-btn" color="warn" mat-dialog-close vertical-align="middle" />
    </div>
  </mat-toolbar>

  <div class="body-wrapper" fxLayout="row" fxLayoutAlign="space-between stretch">
    <div class="target block" fxFlex="49">
      <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
        <span>اطلاعات</span>
        <jam-icon name="info" />
      </mat-toolbar>

      <div class="block-body" fxLayout="column" fxLayoutAlign="center center">
        <mat-form-field appearance="outline">
          <mat-label>نوع آیتم</mat-label>
          <mat-select [(ngModel)]="target" [disabled]="isEditMode">
            <mat-option value="type">اندازه</mat-option>
            <mat-option value="binding">صحافی</mat-option>
            <mat-option value="color">رنگ طلق</mat-option>
          </mat-select>
        </mat-form-field>
        <form *ngIf="target === 'type' && pointer != 'کاور' " [formGroup]="typeFormGroup">
          <mat-form-field appearance="outline">
            <mat-label>نام آیتم</mat-label>
            <input [placeholder]="'A4, A5'" formControlName="name" type="text" matInput />
          </mat-form-field>
        </form>
        <form *ngIf="target === 'type' && pointer == 'کاور'" [formGroup]="typeCoverFormGroup">
          <mat-form-field appearance="outline">
            <mat-label>نام آیتم</mat-label>
            <input [placeholder]="'A4, A5'" formControlName="name" type="text" matInput />
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex.gt-sm="48" fxFlex="100">
            <mat-label>قیمت</mat-label>
            <input formControlName="price" type="number" matInput />
            <jam-icon name="price"></jam-icon>
          </mat-form-field>
        </form>
        <form *ngIf="target === 'binding'" [formGroup]="bindingFormGroup">
          <mat-form-field appearance="outline">
            <mat-label>نام آیتم</mat-label>
            <input [placeholder]="'اسم صحافی'" formControlName="name" type="text" matInput />
          </mat-form-field>
        </form>
      </div>
    </div>
    <div class="binding block" fxFlex="100" *ngIf="target === 'binding'">
      <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
        <span>صحافی</span>
        <jam-icon name="book"></jam-icon>
      </mat-toolbar>

      <div class="block-body">
        <form fxLayout="column" [formGroup]="bindingFormGroup">

          <div fxLayout="row wrap" fxLayoutGap="16px">
            <mat-form-field appearance="outline" fxFlex.gt-sm="48" fxFlex="100">
              <mat-label>تعداد</mat-label>
              <input formControlName="amount" type="number" matInput />
              <mat-slide-toggle matSuffix color="warn" formControlName="infinite">
                بی‌نهایت
              </mat-slide-toggle>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex.gt-sm="48" fxFlex="100">
              <mat-label>قیمت</mat-label>
              <input formControlName="price" type="number" matInput />
              <jam-icon name="price"></jam-icon>
            </mat-form-field>
          </div>
          <mat-slide-toggle formControlName="needsTalc">امکان انتخاب طلق</mat-slide-toggle>

          <div style="margin-top: 20px ;" layout="row" layout-margin
            *ngIf="priceRanges && priceRanges.controls.length > 0">
            <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
              <span>رنج قیمت‌ها</span>
              <jam-icon name="book"></jam-icon>
            </mat-toolbar>

            <div layout="row" formArrayName="priceRanges">
              <div *ngFor="let range of priceRanges.controls; let i = index" [formGroupName]="i"
                class="price-range-card">
                <mat-card-title>بازه {{ i + 1 }}</mat-card-title>
                <mat-card-content fxLayout="row wrap" fxLayoutGap="5px">
                  <mat-form-field appearance="outline" fxFlex.gt-sm="30" fxFlex="10">
                    <mat-label>حداقل تعداد</mat-label>
                    <input matInput formControlName="min" type="number" required />
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex.gt-sm="30" fxFlex="10">
                    <mat-label>حداکثر تعداد</mat-label>
                    <input matInput formControlName="max" type="number" required />
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex.gt-sm="30" fxFlex="10">
                    <mat-label>قیمت</mat-label>
                    <input matInput formControlName="price" type="number" required />
                  </mat-form-field>
                  <div   appearance="outline" fxFlex.gt-sm="5" fxFlex="5">
                      <mat-icon  color="warn"   (click)="removePriceRange(i)" *ngIf="priceRanges.length > 1">delete</mat-icon>
                      <mat-icon  color="primary" (click)="addPriceRange()" *ngIf="i === priceRanges.length - 1">add</mat-icon>
                  </div>
                </mat-card-content>
              </div>
            </div>
          </div>


        </form>
      </div>
    </div>

    <div class="binding block" fxFlex="100" *ngIf="target === 'bindingSalaryFee'">
      <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
        <span>صحافی</span>
        <jam-icon name="book"></jam-icon>
      </mat-toolbar>

      <div class="block-body">
        <form fxLayout="column" [formGroup]="bindingSalaryFeeFormGroup">

          <div fxLayout="row wrap" fxLayoutGap="16px">
            <!-- <mat-form-field appearance="outline" fxFlex.gt-sm="48" fxFlex="100">
              <mat-label>تعداد</mat-label>
              <input formControlName="amount" type="number" matInput />
              <mat-slide-toggle matSuffix color="warn" formControlName="infinite">
                بی‌نهایت
              </mat-slide-toggle>
            </mat-form-field> -->

            <mat-form-field appearance="outline" fxFlex.gt-sm="48" fxFlex="100">
              <mat-label>قیمت</mat-label>
              <input formControlName="bindSalaryFee" type="number" matInput />
              <jam-icon name="price"></jam-icon>
            </mat-form-field>
          </div>


        </form>
      </div>
    </div>

    <div *ngIf="target === 'type' && pointer != 'کاور' " fxFlex="49" class="type block">
      <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
        <span>اندازه صفحات</span>
        <jam-icon name="book"></jam-icon>
      </mat-toolbar>

      <div [ngSwitch]="isEditMode" class="block-body" fxLayout="column" fxLayoutAlign="center center">
        <div class="name"></div>

        <!-- Add functionality -->
        <div class="add" *ngSwitchCase="false">
          <form [formGroup]="typeFormGroup" fxLayout="column">
            <div class="group" fxLayout="column">
              <mat-form-field appearance="outline">
                <mat-label>قیمت سیاه و سفید</mat-label>
                <input type="number" formControlName="bw1" matInput />
                <span matSuffix>یک‌رو</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>قیمت سیاه و سفید</mat-label>
                <input type="number" matInput formControlName="bw2" />
                <span matSuffix>دورو</span>
              </mat-form-field>
            </div>

            <div class="group" fxLayout="column">
              <mat-form-field appearance="outline">
                <mat-label>قیمت رنگی</mat-label>
                <input formControlName="c1" type="number" matInput />
                <span matSuffix>یک‌رو</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>قیمت رنگی</mat-label>
                <input formControlName="c2" type="number" matInput />
                <span matSuffix>دورو</span>
              </mat-form-field>
            </div>

            <div class="group" fxLayout="column">
              <mat-form-field appearance="outline">
                <mat-label>قیمت نیمه رنگی</mat-label>
                <input formControlName="hc1" type="number" matInput />
                <span matSuffix>یک‌رو</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>قیمت نیمه رنگی</mat-label>
                <input formControlName="hc2" type="number" matInput />
                <span matSuffix>دورو</span>
              </mat-form-field>
            </div>
          </form>
        </div>

        <!-- Edit functionality -->
        <div class="edit" *ngSwitchCase="true">
          <form [formGroup]="typeFormGroup" fxLayout="column">
            <div class="group" fxLayout="column">
              <mat-form-field appearance="outline">
                <mat-label>قیمت سیاه و سفید</mat-label>
                <input type="number" formControlName="bw1" matInput />
                <span matSuffix>یک‌رو</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>قیمت سیاه و سفید</mat-label>
                <input type="number" matInput formControlName="bw2" />
                <span matSuffix>دورو</span>
              </mat-form-field>
            </div>

            <div class="group" fxLayout="column">
              <mat-form-field appearance="outline">
                <mat-label>قیمت رنگی</mat-label>
                <input formControlName="c1" type="number" matInput />
                <span matSuffix>یک‌رو</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>قیمت رنگی</mat-label>
                <input formControlName="c2" type="number" matInput />
                <span matSuffix>دورو</span>
              </mat-form-field>
            </div>

            <div class="group" fxLayout="column">
              <mat-form-field appearance="outline">
                <mat-label>قیمت نیمه رنگی</mat-label>
                <input formControlName="hc1" type="number" matInput />
                <span matSuffix>یک‌رو</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>قیمت نیمه رنگی</mat-label>
                <input formControlName="hc2" type="number" matInput />
                <span matSuffix>دورو</span>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="color block" fxFlex="49" *ngIf="target === 'color'">
      <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
        <span>رنگ طلق</span>
        <jam-icon name="book"></jam-icon>
      </mat-toolbar>

      <div class="block-body">
        <form fxLayout="column" [formGroup]="talcColorFormGroup">
          <div class="form-box-" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-form-field appearance="outline" fxFlex="49">
              <mat-label>اسم</mat-label>
              <input formControlName="name" type="text" matInput />
            </mat-form-field>

            <label>انتخاب رنگ</label>
            <input formControlName="colorCode" type="color" matInput />
            <jam-icon name="price"></jam-icon>
          </div>
        </form>
      </div>
    </div>




  </div>
</div>